// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"ef9d23b92a646c1448fb","548":"155a082564811ea4d224","710":"41914cb4d49d2092a27d"}[chunkId] + ".bundle.js";
};